module.exports = __webpack_public_path__ + "static/media/SHOPEEPAY.cdc879d6.svg";